import React from 'react';
import { withTheme } from 'styled-components';
import { transparentize } from 'utils/color';
import { Figure } from './Figure.styled';

type CoursePassedBackgroundProps = {
  theme: { [key: string]: any };
};
export const CoursePassedBackground = (props: CoursePassedBackgroundProps) => (
  <Figure
    width="260px"
    height="122px"
    viewBox="0 0 260 122"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <defs>
      <filter
        id="prefix__a"
        width="100%"
        height="100%"
        x="0%"
        y="0%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur in="SourceGraphic" />
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        fill={transparentize(props.theme.colors.textColor, 1.0)}
        d="M74.48.423H20.984s-9.378 1.012-9.378 8.467c0 7.454 9.378 8.466 9.378 8.466l31.828.06s7.447 1.452 7.447 7.983c0 6.53-7.447 8.466-7.447 
        8.466H36.368s-13.348.815-13.348 8.89c0 8.074 13.348 9.312 13.348 9.312H9.479S0 53.7 0 60.473C0 67.246 9.48 69 9.48 69h207.865s11.703-1.33 
        11.703-8.527c0-7.196-11.703-8.406-11.703-8.406H197.02s-11.868-.707-12.08-8.042c-.211-7.336 12.08-8.709 12.08-8.709l23.586-.816s12.31 1.814 
        12.31-8.376-11.325-8.768-11.325-8.768l28.253.06S260 16.806 260 8.89C260 .973 249.844 0 249.844 0L74.479.423z"
        filter="url(#prefix__a)"
        opacity=".02"
        transform="translate(0 53)"
      />
      <g fill={transparentize(props.theme.colors.correctColor, 1.0)} fill-rule="nonzero">
        <path
          d="M44.32 5.16c-.357.365-.52.892-.435 1.409L44.28 9l-2.076-1.148c-.22-.122-.463-.183-.705-.183-.242 0-.484.061-.705.183L38.72 
          9l.396-2.431c.085-.517-.078-1.044-.435-1.41L37 3.438l2.321-.355c.494-.075.92-.401 1.14-.871L41.502 0l1.037 2.212c.22.47.647.796 
          1.14.87L46 3.439l-1.68 1.721zM9.395 13.407c-.25.446-.271.997-.056 1.474l1.012 2.246-2.303-.571c-.244-.061-.494-.057-.728.005-.234.063-.452.185-.633.36l-1.709 
          1.646-.246-2.451c-.052-.521-.346-.988-.786-1.25L1.878 13.64l2.15-.944c.458-.2.785-.625.877-1.137l.43-2.405 1.576 1.868c.334.397.83.601 1.327.546l2.334-.258-1.177 
          2.098zM72.605 13.407c.25.446.271.997.056 1.474l-1.012 2.246 2.303-.571c.244-.061.494-.057.728.005.234.063.452.185.633.36l1.709 
          1.646.246-2.451c.052-.521.346-.988.786-1.25l2.068-1.227-2.15-.944c-.458-.2-.785-.625-.877-1.137l-.43-2.405-1.576 
          1.868c-.334.397-.83.601-1.327.546l-2.334-.258 1.177 2.098z"
          transform="translate(88 1)"
        />
      </g>
    </g>
  </Figure>
);
export default withTheme(CoursePassedBackground);
